import React, {useEffect, useState} from 'react';
import {Cell, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';
import api from '../../../../api/axios';
import figureConverter from '../../../../tools/figureConverter'; // Import der Hilfsfunktion
import Cookies from 'js-cookie';
import useRevenueStoreMonth from './RevenueStoreM';

const COLORS = ['#8884d8', '#82ca9d']; // Farben für Kosten und Marge

const RevenueChartM = () => {
    const [colors, setColors] = useState(COLORS);
    const [chartData, setChartData] = useState([]);
    const setTotalRevenue = useRevenueStoreMonth((state) => state.setTotalRevenue);
    const setTotalCosts = useRevenueStoreMonth((state) => state.setTotalCosts);
    const setTotalYield = useRevenueStoreMonth((state) => state.setTotalYield);

    useEffect(() => {
        const getCSSBackgroundColor = (className) => {
            const element = document.createElement('div');
            element.className = className;
            document.body.appendChild(element);
            const bgColor = window.getComputedStyle(element).backgroundColor;
            document.body.removeChild(element);
            return bgColor;
        };

        const color1 = getCSSBackgroundColor('bg-color-1');
        const color2 = getCSSBackgroundColor('bg-color-4');
        setColors([color1, color2]);
    }, []);

    useEffect(() => {
        const fetchMonthlyRevenueData = async () => {
            try {
                const accessToken = Cookies.get('accessToken');

                const response = await api.get('/api/v1/revenue/current/month', {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                const {revenue, costs, yield: profit} = response.data;

                const transformedData = [
                    {name: 'Kosten', value: parseFloat(costs)},
                    {name: 'Rohertrag 1', value: parseFloat(profit)},
                ];

                setChartData(transformedData);
                setTotalRevenue(parseFloat(revenue));
                setTotalCosts(parseFloat(costs));
                setTotalYield(parseFloat(profit));
            } catch (error) {
                console.error('Fehler beim Abrufen der Umsatzdaten:', error);
            }
        };

        fetchMonthlyRevenueData();
    }, [setTotalRevenue, setTotalCosts, setTotalYield]);

    // Tooltip Renderer
    const CustomTooltip = ({active, payload}) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip bg-color-3 rounded-lg p-2 opacity-90 border border-color-1">
                    {payload.map((entry, index) => (
                        <p key={`tooltip-item-${index}`}>{`${entry.name}: ${figureConverter(entry.value, false)}`}</p>
                    ))}
                </div>
            );
        }
        return null;
    };

    return (
        <div className='w-full h-full flex items-center justify-center pt-0 pb-2'>
            <ResponsiveContainer width="100%" height={160}>
                <PieChart>
                    <Pie
                        data={chartData}
                        cx="50%"
                        cy="50%"
                        outerRadius={70}
                        innerRadius={45}
                        dataKey="value"
                        nameKey="name"
                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={colors[index % colors.length]}/>
                        ))}
                    </Pie>
                    <Tooltip content={<CustomTooltip/>}/> {/* CustomTooltip hier hinzugefügt */}
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

export default RevenueChartM;
